function WishList() {
  console.log("whish");
  return "This is wishlist";
}
export default WishList;
